export const NAMESPACES = [
  'AWS/ApplicationELB',
  'AWS/AutoScaling',
  'AWS/AmazonMQ',
  'AWS/Billing',
  'AWS/CloudFront',
  'AWS/CloudSearch',
  'AWS/Events',
  'AWS/DynamoDB',
  'AWS/ECS',
  'AWS/ElastiCache',
  'AWS/EBS',
  'AWS/EC2',
  'AWS/ELB',
  'AWS/ElasticMapReduce',
  'AWS/ES',
  'AWS/Kinesis',
  'AWS/Lambda',
  'AWS/ML',
  'AWS/OpsWorks',
  'AWS/Redshift',
  'AWS/RDS',
  'AWS/Route53',
  'AWS/SNS',
  'AWS/SQS',
  'AWS/S3',
  'AWS/SWF',
  'AWS/StorageGateway',
  'AWS/WAF',
  'AWS/WorkSpaces',
];
